import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Typography from '../../atoms/typography';
import Button from '../../atoms/button';
import Globe from '../../atoms/icon-globe';

const LocalWrapper = styled.div`
  background-color: ${(props) => props.theme.color.backgroundLight};
  color: ${(props) => props.theme.color.brand};
  display: flex;
`;

const StyledButton = styled(Button)`
  background-color: ${(props) => props.theme.color.backgroundLight};
  border-color: ${(props) => props.theme.color.backgroundLight};
  display: flex;
  letter-spacing: normal;
  padding: 0;
`;

const SVG = styled(Globe)`
  align-self: center;
  fill: ${(props) => props.theme.color.brand};
  height: 2rem;
  margin-right: 1rem;
  width: 2rem;
`;

const Divider = styled(Typography)`
  align-self: center;
  padding: 0 0.2rem;
`;

const LocaleTrigger = (props) => (
  <LocalWrapper {...props}>
    <StyledButton inverted>
      <SVG />
      <Typography element="i" like="dec-1">
        {props.country}
      </Typography>
    </StyledButton>
    <Divider element="span" like="dec-1">|</Divider>
    <StyledButton inverted>
      <Typography element="i" like="dec-1">
        {props.currency}
      </Typography>
    </StyledButton>
  </LocalWrapper>
);

LocaleTrigger.defaultProps = {
  country: 'US',
  currency: '$'
};

LocaleTrigger.propTypes = {
  currency: PropTypes.string,
  country: PropTypes.string
};

LocaleTrigger.whyDidYouRender = true;

export default memo(LocaleTrigger);
